import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ApiService } from "src/app/services/api/api.service";

@Component({
  selector: "app-contact-data-sticky-bar",
  templateUrl: "./contact-data-sticky-bar.component.html",
  styleUrls: ["./contact-data-sticky-bar.component.scss"],
})
export class ContactDataStickyBarComponent implements OnInit {
  form!: FormGroup;
  isExpanded = true;
  isSending = false;
  private stringPattern = "^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$";
  private emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
  private cellPhonePattern = "^3\\d{9}$";

  @Input() store: string;
  @Input() titleSticky: string;

  constructor(private fb: FormBuilder, private apiService: ApiService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: this.fb.control("", [
        Validators.required,
        Validators.pattern(this.stringPattern),
      ]),
      phone: this.fb.control("", [
        Validators.required,
        Validators.pattern(this.cellPhonePattern),
      ]),
      email: this.fb.control("", [
        Validators.required,
        Validators.pattern(this.emailPattern),
      ]),
    });
  }

  submit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSending = true;
    this.apiService
      .postLambda("publication-characteristics/v1/plan-intention", {
        ...this.form.value,
        store: Number(this.store),
      })
      .subscribe(
        (_data) => {
          this.isSending = false;
          this.isExpanded = false;
          this.form.reset();
          this.form.markAsUntouched();
        },
        (_error) => {
          this.isSending = false;
          this.isExpanded = false;
        }
      );
  }
  getError(field: string, errorType: string): boolean {
    const control = this.form.get(field);
    return control.touched && control.errors && control.errors[errorType];
  }

  getPlaceholder(field: string): string {
    const placeholders = {
        name: "Nombre y Apellido",
        email: "Correo electrónico",
        phone: "Número de celular"
    };

    return placeholders[field] || "";
}

  getErrorMessage(field: string, errorType: string): string {
    const errorMessages = {
      required: {
        default: "El campo es requerido",
      },
      pattern: {
        email: "Ingresa un correo electrónico válido",
        phone: "Ingresa tu número de celular válido",
        name: "El campo es alfabético",
      },
    };

    return (
      errorMessages[errorType]?.[field] ||
      errorMessages[errorType]?.default ||
      ""
    );
  }
}
